// extracted by mini-css-extract-plugin
module.exports = {"row":"_3XFsGaIQ9ibzyGp1kTdQgk","col":"_1zTzWfNU-Cmk4nQ8wviFsT","title":"_3FWRQF-u2ahcvRbouw6lIk","container":"_3IigUAfmmeK-dvKtmqpP8l"};